import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './HeroSection.css';

function HeroSection({ isEnglish }) {
  const [index, setIndex] = useState(0);

  const slides = [
    {
      image: '/images/hero1.jpg',
      title: 'Welcome to Akebono',
      jpTitle: 'ようこそ金沢之旅宿 あけぼのへ',
      layout: 'full',
    },
    {
      imageLeft: '/images/garden1.png',
      imageRight: '/images/garden2.jpg',
      title: 'A seasonal garden',
      jpTitle: '季節の庭園に包まれて',
      layout: 'split',
    },
    {
      imageLeft: '/images/machiya1.jpg',
      imageRight: '/images/machiya2.jpg',
      title: '170㎡ for up to 8 guests',
      jpTitle: '最大8名、170㎡のゆとり',
      layout: 'split',
    },
    {
      imageLeft: '/images/access1.jpg',
      imageRight: '/images/access2.jpg',
      title: 'Stroll to Local Attractions',
      jpTitle: '金沢観光に最適の好立地',
      layout: 'split',
    },
    {
      imageLeft: '/images/crafts1.jpg',
      imageRight: '/images/crafts2.jpg',
      title: 'Crafts from Ishikawa & Noto',
      jpTitle: '石川・能登の工芸品とともに',
      layout: 'split',
    },
    {
      imageLeft: '/images/renovation1.jpg',
      imageRight: '/images/renovation2.jpg',
      title: 'Renovated for comfort',
      jpTitle: '快適に生まれ変わった町家',
      layout: 'split',
    },
    {
      image: '/images/hero2.jpg',
      title: 'A Special Moment Awaits',
      jpTitle: 'あけぼので、特別なひと時を',
      layout: 'full',
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const current = slides[index];

  return (
    <section className="hero">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          className="hero-bg-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.5 }}
        >
          {current.layout === 'split' ? (
            <>
              <div
                className="hero-bg-half zoom left"
                style={{ backgroundImage: `url(${current.imageLeft})` }}
              />
              <div
                className="hero-bg-half zoom right"
                style={{ backgroundImage: `url(${current.imageRight})` }}
              />
            </>
          ) : (
            <div
              className="hero-bg-full zoom"
              style={{ backgroundImage: `url(${current.image})` }}
            />
          )}
        </motion.div>
      </AnimatePresence>

      <div className="hero-overlay">
        <motion.div
          className="hero-content"
          key={current.title}
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 5, delay: 1.0, ease: 'easeOut' }}
        >
          <h1 className="hero-title">
            {isEnglish ? current.title : current.jpTitle}
          </h1>
        </motion.div>

        <a href="#intro" className="scroll-down" aria-label={isEnglish ? 'Scroll down' : '下にスクロール'}>
          <span className="arrow-hero">&#x25BC;</span>
        </a>
      </div>
    </section>
  );
}

export default HeroSection;
